import { createAction, props } from '@ngrx/store';
import { ErrorMessage } from '../error/error-message.model';
import { TemplateCt } from '../template-ct/template-ct.model';
import { Content, DNComment } from './content.model';

export const loadContent = createAction(
	'[Content] LoadContent',
	props<{ userId: number; contentId: number; template: TemplateCt,callbackUrl:string }>()
);

export const loadContentSuccess = createAction(
	'[Content] LoadContentSuccess',
	props<{ datiContent: Content; template: TemplateCt; userId: number,callbackUrl:string }>()
);

export const loadContentFailure = createAction(
	'[Content] LoadContentFailure',
	props<{ error: ErrorMessage }>()
);

export const clearCurrentContent = createAction('[Content]  clearCurrentContent');

export const loadContentList = createAction(
	'[Content] LoadContentList',
	props<{
		template: string;
		userId: number;
		fromWhere: number;
		howMany: number;
		premium: boolean;
	}>()
);

export const loadContentListSuccess = createAction(
	'[Content] LoadContentListSuccess',
	props<{ contentListData: Content[] }>()
);
export const loadContentListFailure = createAction(
	'[Content] LoadContentListFailure',
	props<{ error: ErrorMessage }>()
);

export const loadContentListByCategory = createAction(
	'[Content] loadContentListByCategory',
	props<{
		categoryId: number;
		userId: number;
		fromWhere: number;
		howMany: number;
		premium: boolean;
	}>()
);

export const loadContentListByCategorySuccess = createAction(
	'[Content] loadContentListByCategorySuccess',
	props<{ contentListData: Content[] }>()
);

export const loadContentListByCategoryFailure = createAction(
	'[Content] loadContentListByCategoryFailure',
	props<{ error: ErrorMessage }>()
);
export const clearList = createAction('[Content]  clearList');

export const loadContentSearchList = createAction(
	'[Content] loadContentSearchList',
	props<{
		userId: number;
		searchKey: string;
		fromWhere: number;
		howMany: number;
	}>()
);

export const loadContentSearchListSuccess = createAction(
	'[Content] loadContentSearchListSuccess',
	props<{ contentSearchListData: Content[] }>()
);
export const loadContentSearchListFailure = createAction(
	'[Content] loadContentSearchListFailure',
	props<{ error: ErrorMessage }>()
);

// Comments

export const insertComment = createAction(
	'[Content] InsertComment',
	props<{
		parentId: number;
		parentTemplate: TemplateCt;
		title: string;
		text: string;
		authorId: number;
		commentTemplate: TemplateCt;
		attachmentId: number;
		attachmentTemplate: TemplateCt;
	}>()
);

// InsertComment call returns the new subTree of comments starting from the parentId where the comment has been insert into
export const insertCommentSuccess = createAction(
	'[Content] InsertCommentSuccess',
	props<{ comments: DNComment[] }>()
);

export const insertCommentFailure = createAction(
	'[Content] InsertCommentFailure',
	props<{ error: ErrorMessage }>()
);

export const loadComments = createAction(
	'[Content] LoadComments',
	props<{ commentId: number; userId: number; template: TemplateCt }>()
);

export const loadCommentsSuccess = createAction(
	'[Content] LoadCommentsSuccess',
	props<{ comments: DNComment[] }>()
);

export const loadCommentsFailure = createAction(
	'[Content] LoadCommentsFailure',
	props<{ error: ErrorMessage }>()
);

// Media
export const clearTemporaryMedia = createAction('[Content] ClearTemporaryMedia');

export const uploadTemporaryMedia = createAction(
	'[Content] UploadTemporaryMedia',
	props<{ media: File }>()
);

export const uploadTemporaryMediaSuccess = createAction(
	'[Content] UploadTemporaryMediaSuccess',
	props<{ mediaTemporaryName: string }>()
);

export const uploadTemporaryMediaFailure = createAction(
	'[Content] UploadTemporaryMediaFailure',
	props<{ error: ErrorMessage }>()
);

export const insertMediaAndComment = createAction(
	'[Content] InsertMediaAndComment',
	props<{
		attachmentTemplate: TemplateCt;
		fileName: string;
		parentId: number;
		parentTemplate: TemplateCt;
		title: string;
		text: string;
		authorId: number;
		commentTemplate: TemplateCt;
	}>()
);

export const insertMediaAndCommentSuccess = createAction(
	'[Content] InsertMediaAndCommentSuccess',
	props<{ comments: DNComment[] }>()
);

export const insertMediaAndCommentFailure = createAction(
	'[Content] InsertMediaAndCommentFailure',
	props<{ error: ErrorMessage }>()
);
